import { render } from "./PasswordConfirmation.vue?vue&type=template&id=02c2e8d8&scoped=true"
import script from "./PasswordConfirmation.vue?vue&type=script&lang=js"
export * from "./PasswordConfirmation.vue?vue&type=script&lang=js"

import "./PasswordConfirmation.vue?vue&type=style&index=0&id=02c2e8d8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c2e8d8"]])

export default __exports__